const now = Date.now()
const url = ('?from=wx_' + now) + (window.location.origin)

export const urlRedirect = {
  '/couponPackageCheck/check': `${url}/#/cardCheck/check`,
  '/giftCheck/check': `${url}/#/cardCheck/check`,
  '/couponCheck/check': `${url}/#/cardCheck/check`
}
